export default __webpack_public_path__ + "static/media/shadow-footer-create-contract.3b09ad9b.svg";